import { Alert, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getInfoRestaurant, getTextExcludesVat } from '~/utils'

const ExcludesVAT = () => {
  const { menuExcludesVAT } = getInfoRestaurant()
  const { t, i18n } = useTranslation()

  if (!menuExcludesVAT) return null

  return (
    <Alert severity="info" sx={{ mt: 1 }}>
      <Typography paddingTop="1px">{t(getTextExcludesVat(i18n.language))}</Typography>
    </Alert>
  )
}

export default ExcludesVAT
